import { render, staticRenderFns } from "./FeatureRemoveImageButton.vue?vue&type=template&id=5c6d81a3&scoped=true"
import script from "./FeatureRemoveImageButton.vue?vue&type=script&lang=js"
export * from "./FeatureRemoveImageButton.vue?vue&type=script&lang=js"
import style0 from "./FeatureRemoveImageButton.vue?vue&type=style&index=0&id=5c6d81a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d81a3",
  null
  
)

export default component.exports